const addKey = "add-default-proxy";

const addApplicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/[0-9]*\/proxies\/-2$/);
};

const addModify = (resp) => {
	if(resp.status !== 400 && resp.status !== 404 && resp.status !== 403 && resp.status !== 405) {
		throw resp;
	}

	resp.status = 200;
	resp.data.Success = true;
	delete resp.data.Errors;
	delete resp.data.Informations;

	resp.data.Data = {
		Id: -2,
		Code: "default-test",
		Name: "Test Operation Result Response",
		Method: "POST",
		Type: {
			Id: 3,
			Code: "QUERY",
			Name: "Query",
			Description: "Query / Get Information"
		}	
	};

	return resp;
};

const handleKey = "handle-default-proxy";

const handleApplicable = (resp) => {
	return resp.config.method === "POST" && resp.config.url.match(/api\/forms\/[0-9]*\/proxies\/default-test$/);
};

const handleModify = (resp) => {
	if(resp.status !== 400 && resp.status !== 404 && resp.status !== 403 && resp.status !== 405) {
		throw resp;
	}

	resp.status = 200;
	resp.data.Success = true;
	delete resp.data.Errors;
	delete resp.data.Informations;

	resp.data = {
		...resp.data,
		Success: true,
		// Data: {
		// 	paul: "is great",
		// 	number: 1
		// }
		Errors: ["error 1", "error 2", "error 3"],
		Warnings: ["warning 1", "warning 2", "warning 3"],
		Informations: ["info 1", "info 2", "info 3"]
	};

	return resp;
};


export const handleProxyDefault = [handleKey, handleApplicable, handleModify];
export const addProxyDefault = [addKey, addApplicable, addModify];